export default "__VITE_ASSET__5e2e3ffd__"